import Table from '../../../../../../common/components/table';


export const PlansValuesComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedPlansValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedPlansValues}
                onEdit={handleEdit} headingName="Plans Details"
                additionButtons={additionButtons} onDelete={handleDelete} />
        </div>
    )
}
export default PlansValuesComponent;
